import QRCodeContainer from '../../atoms/container/qrCodeContainer';
import QRCodeText from '../../atoms/text/qrCodeText';
import QrGenerator from '../../elements/qr/qrGenerator';
import Pages from '../../../../shared/types/enums/pages';
import { ILoginObservable } from '../../../../shared/types/interfaces/login';
import { Observer, Subscription } from 'rxjs';
import {
  checkDevice,
  codeObservable,
} from '../../../../shared/api/login/observable';
import { pushRoute } from '../../../../shared/store/thunks/route.thunk';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { useEffect, useRef, useState } from 'react';
import FlavourConfig from '../../../../shared/config/flavours/index';
import keepWatchingRequest from '@shared/api/initial/keepWatchingRequest';

const MAX_TRIES = 60; // Five minutes

function QRCode({ url }: { url: string }) {
  const dispatch = useAppDispatch();
  const subscriber = useRef<Subscription>();
  const [code, setCode] = useState('');

  useEffect(() => {
    if (subscriber.current) {
      subscriber.current.unsubscribe();
    }
    let tries = 0;
    const observer: Observer<ILoginObservable> = {
      next: (val: { code: string; validated: boolean; newCode: boolean }) => {
        setCode(val.code);
        if (val.newCode && val.code) {
          subscriber.current?.unsubscribe;
          subscriber.current = checkDevice(val.code).subscribe(
            observer as Partial<Observer<unknown>>
          );
        }
        if (val.validated) {
          subscriber.current?.unsubscribe();
          keepWatchingRequest().then(() => {
            dispatch(
              pushRoute({
                route: { Page: Pages.SUCCESSFUL_LINK, overwrite: true },
              })
            );
          });
        } else {
          tries++;
          if (tries === MAX_TRIES) {
            subscriber.current?.unsubscribe();
            if (FlavourConfig.languages.length > 1) {
              dispatch(
                pushRoute({ route: { Page: Pages.LANGUAGES, overwrite: true } })
              );
            } else {
              dispatch(
                pushRoute({ route: { Page: Pages.WELCOME, overwrite: true } })
              );
            }
          }
        }
      },
      error: () => {
        console.error('Error recovering code');
      },
      complete: () => {
        return null;
      },
    };
    subscriber.current = codeObservable.subscribe(
      observer as Partial<Observer<unknown>>
    );
    return () => {
      subscriber?.current?.unsubscribe();
    };
  }, [url]);

  return (
    <QRCodeContainer>
      {code && <QrGenerator url={`${url}?code=${code}`} />}
      <QRCodeText>{code}</QRCodeText>
    </QRCodeContainer>
  );
}

export default QRCode;
